module.exports = __webpack_public_path__ + "static/media/playalong-default.91eff88e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/playalong-default.jpg
// module id = ./src/assets/images/playalong-default.jpg
// module chunks = 0